var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth_nj"},[_vm._m(0),(_vm.isLoaded)?_c('router-view',{attrs:{"isRegistered":_vm.isRegistered,"registeredData":_vm.registeredData,"registeredFileList":_vm.registeredFileList},on:{"refetch":_vm.refetch}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("本人確認情報登録")])])
}]

export { render, staticRenderFns }